/** @format */

export const isEmpty = (arr = []) => !arr.length
